import { AxiosResponse } from 'axios'
import { http } from '@/core/classes/HTTP.class'

import { LtlPackageFiles } from '@/core/types/LTL.types'

const BASE_URL = process.env.VUE_APP_GATEWAY_URL

type LtlPackageFilesResponse = Promise<AxiosResponse<LtlPackageFiles>>

export function getLtlPackageFiles(
    invoiceNumber: string
): Promise<AxiosResponse<LtlPackageFilesResponse>> {
    return http.get(`${BASE_URL}/inventory/api/write-offs/package-files/${invoiceNumber}`)
}

export default {
    getLtlPackageFiles,
}
